(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BORDER, COLOR, SPACE } from "../../constants/style.js";
import { Div, Flex } from "../layout";
import { Icon } from "../icons";
var StyledMessage = styled(Flex).withConfig({
  displayName: "Message__StyledMessage",
  componentId: "sc-7um2iu-0"
})(["border:", " solid ", ";flex-direction:row;align-items:center;padding:", ";border-radius:", ";margin-bottom:", ";&:last-child{margin-bottom:0;}svg{color:", ";}border-color:", ";", ""], BORDER.width.md, function (props) {
  return props.theme.styles.secondary.color;
}, SPACE.md, BORDER.radius.sm, SPACE.xl, function (props) {
  return COLOR[props.variant] ? COLOR[props.variant].base : '' || props.theme.styles.colors[props.variant] || props.theme.styles.colors.tertiary;
}, function (props) {
  return props.theme.styles.colors.divider;
}, function (props) {
  switch (props.variant) {
    case 'plain':
      return "\n          color: ".concat(COLOR.gray.darkest, ";\n          border-color: ").concat(COLOR.gray.lighter, ";\n          background-color: ").concat(COLOR.offWhite, ";\n        ");

    case 'info':
    case 'warning':
    case 'error':
      return "\n          color: ".concat(COLOR[props.variant].base, ";\n          border-color: ").concat(COLOR[props.variant].base, ";\n          background-color: ").concat(COLOR[props.variant].lightest, ";\n        ");

    default:
      break;
  }
});
var IconWrapper = styled(Div).withConfig({
  displayName: "Message__IconWrapper",
  componentId: "sc-7um2iu-1"
})(["padding-right:", ";"], SPACE.sm);

var Message = function Message(props) {
  var children = props.children,
      icon = props.icon;

  var variant = props.variant,
      category = props.category,
      rest = _objectWithoutProperties(props, ["variant", "category"]);

  return React.createElement(StyledMessage, _extends({}, rest, {
    variant: variant || category
  }), icon ? React.createElement(IconWrapper, null, React.createElement(Icon, {
    name: icon
  })) : null, children);
};

Message.propTypes = {
  // TODO: Export available icons from Icon and set icon to oneOf them
  icon: PropTypes.string,
  category: PropTypes.oneOf(['error', 'info']),
  variant: PropTypes.oneOf(['plain', 'error', 'warning', 'info'])
};
Message.defaultProps = {
  variant: 'plain'
};
var _default = Message;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledMessage, "StyledMessage", "/home/vsts/work/1/s/src/components/messages/Message.js");
  reactHotLoader.register(IconWrapper, "IconWrapper", "/home/vsts/work/1/s/src/components/messages/Message.js");
  reactHotLoader.register(Message, "Message", "/home/vsts/work/1/s/src/components/messages/Message.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/messages/Message.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();